import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useBulletin } from '../../context/bulletin';

interface MessageBulletinDateProps {
  message?: string;
  isDisplayedOnDayDate?: boolean;
}

const MessageBulletinDate = ({
  message = 'Bulletin of',
  isDisplayedOnDayDate = false,
}: MessageBulletinDateProps) => {
  const { reportId, variableId = reportId } = useParams();

  const { bulletinType, isLatestBulletin, bulletinDate, bulletinDefaultDate } =
    useBulletin();

  const code = reportId ? 'r' : 'v';

  if ((!isDisplayedOnDayDate && isLatestBulletin) || !bulletinDate) {
    return null;
  }

  return (
    <div className="card info">
      <span
        style={{
          display: 'flex',
          gap: 10,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <p style={{ marginBottom: 0 }}>
          {message} {bulletinDate.replaceAll('-', '/')}.
        </p>
        {!isLatestBulletin && (
          <Link
            to={`/bulletin/${bulletinType}/${bulletinDefaultDate}/${code}/${variableId}`}
          >
            Go back to the latest bulletin.
          </Link>
        )}
      </span>
    </div>
  );
};

export default MessageBulletinDate;
